// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.TableHeaderCell.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import classnames from 'classnames';
import { isUndefined } from 'lodash/fp';

const SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC',
  UNSORT: ''
};
export default class TableHeaderCell extends Component {
  onSortChange = (e: any) => {
    e.preventDefault();

    const { columnKey } = this.props;
    let sortDirection = this.sortDirection();

    // update sort direction
    sortDirection = this.sortDirection(changeSortDirection(sortDirection));

    if (this.props.onSortChange) {
      this.props.onSortChange(columnKey, sortDirection);
    }

    function changeSortDirection(sortDir) {
      switch (sortDir) {
        case SortTypes.ASC:
          return SortTypes.DESC;
        case SortTypes.DESC:
          return SortTypes.UNSORT;
        case SortTypes.UNSORT:
          return SortTypes.ASC;
        default:
          return SortTypes.ASC;
      }
    }
  }

  sortDirection(newValue) {
    const { columnKey, sortInfo } = this.props;

    if (!isUndefined(newValue) && columnKey) {
      return (sortInfo[columnKey] = newValue);
    } else if (!columnKey || isUndefined(sortInfo[columnKey])) {
      return null;
    } else {
      return sortInfo[columnKey];
    }
  }

  renderIcon() {
    const sortDirection = this.sortDirection();

    if (!sortDirection) {
      return null;
    }

    const iconClass = classnames(
      'pull-right',
      {
        'icon-down-open': sortDirection === SortTypes.DESC,
        'icon-up-open': sortDirection !== SortTypes.DESC
      }
    );

    return <i className={iconClass} />;
  }

  render() {
    const { sortable, infoIconOptions, title } = this.props;
    const classHeader = classnames({ unsort: !sortable });

    return (
      <span>
        <a onClick={sortable && this.onSortChange} className={classHeader} title={title}>
          {title}
        </a>
        {infoIconOptions && <span className={infoIconOptions.iconClass} title={infoIconOptions.iconTitle} />}
        {this.renderIcon()}
      </span>
    );
  }
}


// WEBPACK FOOTER //
// ./ui/share/components/controls/DataGrid/Izenda.TableHeaderCell.js